import { Controller } from "@hotwired/stimulus"

// Switch Mensile|Annuale della pagina abbonamento: alterna le due griglie
// pre-renderizzate e sposta lo stato "attivo" sui bottoni del segmented.
export default class extends Controller {
  static targets = ["monthly", "yearly", "monthlyButton", "yearlyButton"]
  static classes = ["active", "inactive"]

  showMonthly() {
    this.#toggle(true)
  }

  showYearly() {
    this.#toggle(false)
  }

  #toggle(monthly) {
    this.monthlyTarget.classList.toggle("hidden", !monthly)
    this.yearlyTarget.classList.toggle("hidden", monthly)
    this.#style(this.monthlyButtonTarget, monthly)
    this.#style(this.yearlyButtonTarget, !monthly)
  }

  #style(button, active) {
    button.classList.remove(...(active ? this.inactiveClasses : this.activeClasses))
    button.classList.add(...(active ? this.activeClasses : this.inactiveClasses))
  }
}
